module.exports = __webpack_public_path__ + "static/media/1.c26869f9.jpg";